import { DetailPage } from '../../components/DetailPage/DetailPage';

import { UserProfileBusinessHoursSection } from './UserDetailBusinessHoursSection/UserProfileBusinessHours.section';

import { UserProfileTabProps } from '@pages/user-profile/UserProfile.decl';

export function UserProfileBusinessHoursPage({ user }: UserProfileTabProps) {
  return (
    <DetailPage data-test='user-detail-business-hours-page'>
      <UserProfileBusinessHoursSection user={user} />
    </DetailPage>
  );
}
